/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { LuisId } from 'src/luis/types/Resource';
import { EntityLabelStore } from 'src/luis/types/stores/utterances/EntityLabelStore';

export class UtteranceStore {
    public readonly id: LuisId;

    public readonly text: string;

    public readonly tokenizedText: string[];

    public readonly createdDate: Date;

    @observable
    public labeledEntities: EntityLabelStore[];

    @observable
    public labeledIntentId: LuisId;

    @observable
    public modifiedDate: Date;

    constructor(id: LuisId, utterance: Partial<UtteranceStore>) {
        this.id = id;
        this.text = utterance.text;
        this.tokenizedText = utterance.tokenizedText;
        this.labeledEntities = utterance.labeledEntities;
        this.labeledIntentId = utterance.labeledIntentId;
        this.createdDate = utterance.createdDate;
        this.modifiedDate = utterance.modifiedDate;
    }

    /**
     * Replaces the current labels array with the given array.
     *
     * @param labels New entity labels.
     */
    @action
    public setLabels(labels: EntityLabelStore[]) {
        this.labeledEntities = [...labels];
        this.modifiedDate = new Date();
    }

    /**
     * Setter for the LabeledIntentId property.
     * @param intentId
     */
    @action
    public setLabeledIntentId(intentId: LuisId) {
        this.labeledIntentId = intentId;
    }
}
